import * as React from 'react';
import { cn } from '../../lib/utils';

/**
 * Поле ввода с видимой меткой (placeholder меткой не считается)
 * и опциональной ошибкой/подсказкой под полем.
 */
const Input = React.forwardRef(
  ({ className, label, error, hint, id, ...props }, ref) => {
    const autoId = React.useId();
    const inputId = id || autoId;
    const describedBy = error ? `${inputId}-error` : hint ? `${inputId}-hint` : undefined;

    return (
      <div className="space-y-sm">
        {label && (
          <label htmlFor={inputId} className="block text-body-xs font-medium text-text-muted">
            {label}
          </label>
        )}
        <input
          ref={ref}
          id={inputId}
          aria-invalid={error ? true : undefined}
          aria-describedby={describedBy}
          className={cn(
            'w-full h-9 px-lg rounded-md bg-surface-raised text-text text-body-sm',
            'border transition-colors duration-200',
            'placeholder:text-text-muted/70',
            error ? 'border-destructive' : 'border-border hover:border-border-strong',
            'disabled:opacity-50 disabled:cursor-not-allowed',
            className
          )}
          {...props}
        />
        {error && (
          <p id={`${inputId}-error`} className="text-body-xs text-destructive flex items-center gap-sm">
            <i className="bi bi-exclamation-circle" aria-hidden="true" />
            {error}
          </p>
        )}
        {!error && hint && (
          <p id={`${inputId}-hint`} className="text-body-xs text-text-muted">
            {hint}
          </p>
        )}
      </div>
    );
  }
);
Input.displayName = 'Input';

export { Input };
